<template>
    <div class="p-6">
      <h2 class="text-xl font-bold mb-4">Crear Orden de Entrega</h2>
  
      <!-- Encabezado -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block font-semibold mb-1">Centro de Activación</label>
          <select v-model="form.id_centro" @change="rellenarDatosCentro" class="input w-full">
            <option disabled value="">Selecciona un centro</option>
            <option v-for="centro in centros" :key="centro.id_centro" :value="centro.id_centro">
              {{ centro.nombre }} - {{ centro.ciudad }}
            </option>
          </select>
        </div>
  
        <div>
          <label class="block font-semibold mb-1">Responsable</label>
          <input v-model="form.contacto_nombre" class="input w-full" />
        </div>
  
        <div>
          <label class="block font-semibold mb-1">Teléfono</label>
          <input v-model="form.contacto_telefono" class="input w-full" />
        </div>
  
        <div>
          <label class="block font-semibold mb-1">Correo</label>
          <input v-model="form.contacto_email" class="input w-full" />
        </div>
  
        <div>
          <label class="block font-semibold mb-1">Asignar Repartidor</label>
          <select v-model="form.id_repartidor" class="input w-full">
            <option disabled value="">Selecciona usuario</option>
            <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
              {{ usuario.nombre }}
            </option>
          </select>
        </div>
  
        <div>
          <label class="block font-semibold mb-1">Fecha programada</label>
          <input type="date" v-model="form.fecha_programada" class="input w-full" />
        </div>
      </div>
  
      <!-- Tabla productos -->
      <div class="mt-6">
        <div class="flex justify-between items-center mb-2">
          <h3 class="text-lg font-bold">Productos en orden</h3>
          <button class="bg-blue-500 text-white px-3 py-1 rounded text-sm" @click="abrirBuscadorProducto">
            + Agregar Producto
          </button>
        </div>
        <div v-if="form.productos.length === 0" class="text-gray-500 text-sm">Sin productos aún.</div>
        <table v-else class="w-full text-sm border mt-2">
          <thead class="bg-gray-100">
            <tr>
              <th class="py-2 px-3 text-left">Producto</th>
              <th class="py-2 px-3 text-left">Número de Serie</th>
              <th class="py-2 px-3">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, i) in form.productos" :key="i" class="border-b">
              <td class="py-2 px-3">{{ p.nombre_producto }}</td>
              <td class="py-2 px-3">{{ p.numero_serie }}</td>
              <td class="py-2 px-3 text-center">
                <button @click="eliminarProducto(i)" class="text-red-600 text-xs hover:underline">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Botón guardar -->
      <div class="mt-6 flex justify-end">
        <button class="bg-green-600 text-white px-6 py-2 rounded" @click="guardarOrden">
          Guardar Orden
        </button>
      </div>
  
      <!-- Modales -->
      <BuscadorProducto
        v-if="modalProductos"
        @cerrar="modalProductos = false"
        @ver-unidades="abrirModalUnidades"
      />
  
      <SeleccionarUnidades
        v-if="modalUnidades"
        :producto="productoSeleccionado"
        @cerrar="modalUnidades = false"
        @agregar="agregarUnidadesSeleccionadas"
      />
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import BuscadorProducto from '@/components/almacen/ordenes/BuscadorProducto.vue'
  import SeleccionarUnidades from '@/components/almacen/ordenes/SeleccionarUnidades.vue'
  
  export default {
    components: { BuscadorProducto, SeleccionarUnidades },
    data() {
      return {
        centros: [],
        usuarios: [],
        modalProductos: false,
        modalUnidades: false,
        productoSeleccionado: null,
        form: {
          id_centro: '',
          contacto_nombre: '',
          contacto_telefono: '',
          contacto_email: '',
          id_repartidor: '',
          fecha_programada: '',
          productos: []
        }
      }
    },
    mounted() {
      this.cargarCentros()
      this.cargarUsuarios()
    },
    methods: {
      async cargarCentros() {
        const res = await axios.get('/api/almacen/centros/listar')
        this.centros = res.data
      },
      async cargarUsuarios() {
        const res = await axios.get('/api/almacen/ordenes/usuarios-repartidores')
        this.usuarios = res.data
      },
      rellenarDatosCentro() {
        const centro = this.centros.find(c => c.id_centro === this.form.id_centro)
        if (centro) {
          this.form.contacto_nombre = centro.contacto_nombre
          this.form.contacto_telefono = centro.contacto_telefono
          this.form.contacto_email = centro.contacto_email
        }
      },
      abrirBuscadorProducto() {
        this.modalProductos = true
      },
      abrirModalUnidades(producto) {
        this.modalProductos = false
        this.productoSeleccionado = producto
        this.modalUnidades = true
      },
      agregarUnidadesSeleccionadas(unidades) {
        this.form.productos.push(...unidades)
        this.modalUnidades = false
      },
      eliminarProducto(index) {
        this.form.productos.splice(index, 1)
      },
      async guardarOrden() {
        try {
          const res = await axios.post('/api/almacen/ordenes/guardar', this.form)
          if (res.data.status === 'ok') {
            alert('Orden guardada con éxito')
            this.$router.push('/dashboard/ordenes')
          }
        } catch (err) {
          console.error('Error al guardar la orden:', err)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .input {
    border: 1px solid #ccc;
    padding: 0.5rem;
    border-radius: 6px;
  }
  </style>
  